var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ef",attrs:{"tabindex":"0"}},[_c('span',{staticClass:"ef__label"},[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"ef__value"},[_vm._v(_vm._s(_vm.value))]),_c('button',{staticClass:"ef__edit",domProps:{"textContent":_vm._s(_vm.$ml.get('edit'))},on:{"click":function($event){return _vm.$emit('click-edit')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }